<template>
    <h3 class="my-5">{{ $root.trans.ticketing_parent_tipologia }}</h3>
    <FormInput :dati='info'
               :formlabel="label"
               :stilestruttura="style"
               :idform="idform"
               :action="action"
               :recaptcha="recaptcha"
               ref="input">
    </FormInput>
    <h3 class="my-5">{{  $root.trans.ticketing_sottotipologie }}</h3>
    <div class="flex items-center" v-for="(tipo, index) in tipifiglio" :key="index+tipo['idform']">
        <div>
            <a @click="rimuoviRiga(index)"
               class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                <i class="pi pi-trash text-red-500 hover:cursor-pointer"></i>
            </a>
        </div>
        <FormInput
            :dati="tipo['info']"
            :formlabel="tipo['label']"
            :stilestruttura="style"
            :idform="tipo['idform']"
            :action="action"
            :recaptcha="recaptcha"
            :ref="'input'+index">
        </FormInput>
    </div>


    <div class="text-right">
        <button @click="nuovaRigaTipo" class="p-button p-component p-button-success">
            <span class="p-button-label">{{ $root.trans.aggiungi }}</span>
        </button>
        <a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary"
           :href="cancel">{{ bottoneannulla }}</a>
        <button @click="salvaTutti" class="p-button p-component p-button-success">
            <span class="p-button-label">{{ bottonesalva }}</span>
        </button>

    </div>
</template>

<script>

import FormInput from './FormInput.vue';

export default {
    name: "TicketingTipoForm",
    components: {
        FormInput,
    },
    props: [
        'dati',
        'struttura',
        'azione',
        'annulla',
        'stilestruttura',
        'id',
        'recaptcha',
        'bottonesalva',
        'bottonesalvacontinua',
        'bottoneannulla',
        'datifigli'
    ],
    data() {
        return {
            cancel: this.annulla,
            action: this.azione,
            info: JSON.parse(this.dati),
            label: JSON.parse(this.struttura),
            style: this.stilestruttura,
            errors: {},
            imginput: false,
            idform: this.id,
            tipifiglio: [],
        };
    },
    beforeMount() {
        if (typeof this.id == "undefined") {
            this.idform = 'maschera';
        } else {
            this.idform = this.id;
        }

    },
    mounted() {
        const thiz = this
        console.log(this.datifigli)
        console.log(this.tipifiglio)
        const figli = JSON.parse(this.datifigli)

        figli.forEach((t) => {
            thiz.buildRiga(t);

        })
        document.addEventListener('formChanged', function (e) {
            this.label = e.detail.newStruttura;
            if (e.detail.newData) {
                thiz.updateData(e.detail.newData)
            }

        });

    },
    methods: {
        updateData: function (newData) {
            this.$refs["input"].info = newData;
        },
        buildRiga(dati, isNew = false){
            const struttura_figlio = JSON.parse(this.struttura);
            struttura_figlio.campi_extra = [this.$root.trans.ticketing_tipo_campi_extra, 'text', '', ''];
            struttura_figlio.richiedi_approvazione = [this.$root.trans.richiedi_approvazione || 'Richiedi approvazione', 'checkbox', '', ''];
            const newTipo = {
                info: dati,
                label: struttura_figlio,
                idform: this.idform + '_' + (this.tipifiglio.length + 1)
            };
            delete newTipo.info.ticketingcontratti_id;
            delete newTipo.label.ticketingcontratti_id;
            delete newTipo.info.sottotipologie_public;
            delete newTipo.label.sottotipologie_public;

            if (!('richiedi_approvazione' in newTipo.info)) {
                newTipo.info.richiedi_approvazione = false;
            } else {
                newTipo.info.richiedi_approvazione = !!newTipo.info.richiedi_approvazione;
            }

            //new row part
            if(isNew){
                delete newTipo.info.id;
                delete newTipo.label.id;
                newTipo.info.nome = '';
                newTipo.info.richiedi_approvazione = false;
            }
            // end new row part
            this.tipifiglio.push(newTipo);
        },
        nuovaRigaTipo() {
            const dati = JSON.parse(this.dati);
            dati.campi_extra = '';
            this.buildRiga(dati,true);
        },
        rimuoviRiga(index) {
            const thiz = this;
            this.tipifiglio.splice(index, 1)

        },
        async salvaTutti() {
            const results = [];
            const res = this.$refs.input.checkForm(3);
            results.push(res)
            const thiz = this;

            this.tipifiglio.forEach((el, index) => {
                const key = 'input' + index;
                const subres = this.$refs[key][0].checkForm(3)
                results.push(subres)
            })

            Promise.allSettled(results).then((res) => {
                const errors = res.filter((r) => r.value === true)
                if (errors.length == 0) {
                    this.sendForm()

                }
            })
        },
        sendForm() {
            var vm = this;
            vm.info['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

            try {
                axios.post(vm.azione, {
                    tipoGenitore: vm.info,
                    tipiFiglio: vm.tipifiglio.map((t)=>t.info)
                }, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(function (response) {
                        if (response.data.success) {
                            this.$toast.add({
                                severity: 'success',
                                summary: this.$root.trans.success_form,
                                detail: this.$root.trans.salvataggio_success,
                                life: 3000
                            });

                            if (response.data.params) {
                                window.location.href = route(response.data.redirect, response.data.params);
                            } else {
                                window.location.href = route(response.data.redirect);
                            }

                        } else {
                            if (response.data.message != null) {
                                this.$toast.add({
                                    severity: 'errors',
                                    summary: this.$root.trans.errors_form,
                                    detail: this.$root.trans[response.data.message],
                                    life: 5000
                                });
                            } else {
                                this.$toast.add({
                                    severity: 'errors',
                                    summary: this.$root.trans.errors_form,
                                    detail: this.$root.trans.salvataggio_errato,
                                    life: 3000
                                });
                            }
                        }
                    }.bind(this));
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.$toast.add({
                        severity: 'errors',
                        summary: this.$root.trans.errors_form,
                        detail: this.$root.trans.salvataggio_errato,
                        life: 3000
                    });
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
